import DebateTerms from "@/components/DebateTerms";
import PrepTimers from "@/components/PrepTimers";
import ProAnalysisPanel from "@/components/ProAnalysisPanel";
import RoundNotes from "@/components/RoundNotes";
import RoundSetup from "@/components/RoundSetup";
import RoundSummary from "@/components/RoundSummary";
import RoundTimer from "@/components/RoundTimer";
import ScorePanel from "@/components/ScorePanel";
import SpeakerPoints from "@/components/SpeakerPoints";
import PreRoundTopicContext from "@/components/PreRoundTopicContext";
import WorkspaceActions from "@/components/WorkspaceActions";

export default function WorkspaceLayout({
  activePreset,
  activeStage,
  ballot,
  exportBallot,
  exportPdf,
  isPro,
  isRoundEnded,
  isRoundStarted,
  isRunning,
  onAddCriterion,
  onBestSpeakerChange,
  onCustomCriterionChange,
  onNoteChange,
  onEndRound,
  onPreset,
  onRemoveCriterion,
  onScoreChange,
  onSpeakerChange,
  onStageChange,
  onTimerReset,
  onTimerToggle,
  onUpdateDetails,
  saveBallot,
  roundVersion,
  savedToAccount,
  seconds,
  teams,
}) {
  return (
    <main className="workspace">
      <div className="workspace-intro">
        <p className="eyebrow">Public Forum ballot</p>
        <h1>
          Judge what was said.
          <br />
          <em>Decide what matters.</em>
        </h1>
        <p className="intro-copy">
          A focused ballot for capturing clash, weighing impacts, and keeping a
          clear round record.
        </p>
        <DebateTerms />
      </div>
      <RoundSetup
        details={ballot.details}
        isLocked={isRoundStarted}
        onChange={onUpdateDetails}
      />
      <PreRoundTopicContext
        isRoundStarted={isRoundStarted}
        resolution={ballot.details.resolution}
      />
      <div className="live-layout">
        <RoundNotes
          activeStage={activeStage}
          notes={ballot.notes}
          onStageChange={onStageChange}
          onNoteChange={onNoteChange}
          teams={teams}
          savedToAccount={savedToAccount}
        />
        <div className="timer-stack">
          <RoundTimer
            seconds={seconds}
            isRunning={isRunning}
            isRoundEnded={isRoundEnded}
            isRoundStarted={isRoundStarted}
            activePreset={activePreset}
            onEndRound={onEndRound}
            onToggle={onTimerToggle}
            onReset={onTimerReset}
            onPreset={onPreset}
          />
          <PrepTimers teams={teams} />
        </div>
      </div>
      <ScorePanel
        customCriteria={ballot.customCriteria}
        teams={teams}
        proScores={ballot.proScores}
        conScores={ballot.conScores}
        onAddCriterion={onAddCriterion}
        onCustomCriterionChange={onCustomCriterionChange}
        onRemoveCriterion={onRemoveCriterion}
        onScoreChange={onScoreChange}
      />
      <SpeakerPoints
        speakers={ballot.speakers}
        bestSpeakerId={ballot.bestSpeakerId}
        onSpeakerChange={onSpeakerChange}
        onBestSpeakerChange={onBestSpeakerChange}
      />
      <RoundSummary
        notes={ballot.notes}
        teams={teams}
        isPro={isPro}
        isRoundEnded={isRoundEnded}
        roundVersion={roundVersion}
      />
      <ProAnalysisPanel
        teams={teams}
        notes={ballot.notes}
        isPro={isPro}
        isRoundEnded={isRoundEnded}
        roundVersion={roundVersion}
      />
      <WorkspaceActions
        exportBallot={exportBallot}
        exportPdf={exportPdf}
        isPro={isPro}
        saveBallot={saveBallot}
      />
    </main>
  );
}